<template>
<div class="reservation-modal">
    <v-card flat class="pa-2 page-header">
        <v-row class="px-2">
            <v-col cols="3">
                <im-data-check :item="item"></im-data-check>
                <im-general :item="item"></im-general>
            </v-col>
            <v-col cols="9">
                <v-row>
                    <v-col cols="7">
                        <im-client :item="item">
                            <template v-slot:client_observations>
                                <div></div>
                            </template>
                        </im-client>
                    </v-col>
                    <v-col cols="5">
                        <im-data-price :item="item">
                            <template v-if="item.channel == 'Booking'" v-slot:commision>
                                <div class="" v-if="item.meta">
                                    <div class="im-label">
                                        {{ $t('reservations.modal.commision') }}
                                    </div>
                                    <div class="regular mt-1 mb-3">
                                        <im-price :price="item.meta.reservation.commissionamount._value" :currency="item.meta.reservation.currencycode._value" fontSize="20" />
                                    </div>
                                </div>
                            </template>
                        </im-data-price>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
    <table style="width:100%">
        <thead>
            <tr>
                <td>
                    <div class="page-header-space"></div>
                </td>
            </tr>
        </thead>
        <tbody style="width:100%">
            <tr>
                <td style="width:100%">

                    <v-row class="content">
                        <v-col offset="3" cols="9">
                            <div class="im-label pt-2">{{ $t('dashboard.reservations.modal.client_observations') }}:</div>
                            <div class="regular" v-if="item.meta">
                                <span v-if="item.meta.reservation.customer.remarks._value">{{ item.meta.reservation.customer.remarks._value }}</span>
                                <span v-else> - </span>
                            </div>
                            <div class="regular" v-else>
                                <span v-if="item.observations.client">{{ item.observations.client }}</span>
                                <span v-else> - </span>
                            </div>
                            <v-card v-if="item.meta" flat>
                                <div class="py-1" v-for="(room, index) in handleMetaReservation()" :key="index">
                                    <im-room-booking class="my-1" :room="room" />
                                </div>
                            </v-card>
                            <div v-else>
                                <div class="py-1" v-for="(room, index) in unique_rooms" :key="index">
                                    <im-room :room="room"></im-room>
                                </div>
                            </div>
                        </v-col>
                    </v-row>

                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td>
                    <div class="footer-space"></div>
                </td>
            </tr>
        </tfoot>
    </table>


</div>
</template>

<script>
import defaults from "../PropDefaults.js";
import IMPrice from '../../small-components/IMPrice.vue';
import IMRoom from './Room.vue';
import IMRoomBooking from './RoomBooking.vue';

import IMClient from '../../items/Reservations/items/Client.vue';
import IMGeneral from '../../items/Reservations/items/General.vue';
import IMDataCheck from '../../items/Reservations/items/DataCheck.vue';
import IMDataPrice from '../../items/Reservations/items/DataPrice.vue';

export default {
    components: {
        'im-price': IMPrice,
        'im-general': IMGeneral,
        'im-client': IMClient,
        'im-data-check': IMDataCheck,
        'im-data-price': IMDataPrice,
        'im-room': IMRoom,
        'im-room-booking': IMRoomBooking,
    },

    props: {
        reservation_id: [Number, String],

    },

    data() {
        return {
            loading: false,
            item: this.$clone(defaults.reservation_item),
            dialog_card: false,
            dialog_invoice: false,
            disable_button: false,

            comments_reservation: [],
            show_invoice: true,
            truncate: true,
        }
    },

    watch: {
        reservation_id: {
            immediate: true,
            handler: function () {
                this.getItem()
                this.show_invoice = true;
                this.truncate = true;
                this.comments_reservation = [];
            }
        }
    },

    created() {
        this.getItem();
    },

    computed: {
        unique_rooms: {
            get: function () {
                let rooms = this.item.rooms;
                let _unArray = [];
                rooms.forEach(function (item) {
                    let isPresent = _unArray.filter(function (elem) {
                        return JSON.stringify({ ...elem
                        }) == JSON.stringify({ ...item
                        })
                    })
                    if(isPresent.length == 0) {
                        _unArray.push(item)
                    }
                })
                _unArray.forEach(function (unique) {
                    let isPresent = rooms.filter(function (elem) {
                        return JSON.stringify({ ...unique
                        }) == JSON.stringify({ ...elem
                        })
                    })
                    unique.show = false;
                    unique.count = isPresent.length;
                })
                return _unArray
            },
            // setter
            set: function (newValue) {}
        },

    },

    methods: {
        checkQTravelDetail(value) {
            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.test(value);
        },
        exitDialogCard() {
            this.dialog_card = false;
            this.getItem();
        },

        handleMetaReservation() {
            if(Array.isArray(this.item.meta.reservation.room)) {
                return this.item.meta.reservation.room
            } else {
                return [this.item.meta.reservation.room]
            }
        },

        getItem() {
            if(!this.reservation_id) {
                return
            }
            this.loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/' + this.reservation_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
}
</script>

<style>
.page-header,
.page-header-space {
    height: 75px;
}

.page-header {
    position: fixed;
    top: 0mm;
    width: 100%;
    z-index: 5;
}

.content {
    z-index: 1;
}

@media print {
    thead {
        display: table-header-group;
    }

    tfoot {
        display: table-footer-group;
    }

    body {
        margin: 0;
    }
}
</style>
